import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "user",
  class: "user"
}
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "pages" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_ArrowRight = _resolveComponent("ArrowRight")
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_UserCompanies = _resolveComponent("UserCompanies")
  const _component_UserContacts = _resolveComponent("UserContacts")
  const _component_UserTopics = _resolveComponent("UserTopics")
  const _component_UserStats = _resolveComponent("UserStats")
  const _component_Tasks = _resolveComponent("Tasks")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode(" Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "parent",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.onGoToTenants && $options.onGoToTenants(...args)))
              }, "Tenants"),
              _createVNode(_component_ArrowRight, { class: "arrow" }),
              _createElementVNode("span", {
                class: "parent",
                onClick: _cache[1] || (_cache[1] = (...args) => ($options.onGoToTenant && $options.onGoToTenant(...args)))
              }, _toDisplayString($data.tenant.name), 1 /* TEXT */),
              _createVNode(_component_ArrowRight, { class: "arrow" }),
              _createTextVNode(_toDisplayString($data.user.email), 1 /* TEXT */)
            ])
          ]),
          _createVNode(_component_Tabs, {
            modelValue: $data.active_tab,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.active_tab) = $event)),
            tabs: $data.tabs,
            bordered: ""
          }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
          _createElementVNode("div", _hoisted_5, [
            ($data.active_tab === 'companies')
              ? (_openBlock(), _createBlock(_component_UserCompanies, {
                  key: 0,
                  tenant: $data.tenant,
                  user: $data.user
                }, null, 8 /* PROPS */, ["tenant", "user"]))
              : _createCommentVNode("v-if", true),
            ($data.active_tab === 'contacts')
              ? (_openBlock(), _createBlock(_component_UserContacts, {
                  key: 1,
                  tenant: $data.tenant,
                  user: $data.user
                }, null, 8 /* PROPS */, ["tenant", "user"]))
              : _createCommentVNode("v-if", true),
            ($data.active_tab === 'topics')
              ? (_openBlock(), _createBlock(_component_UserTopics, {
                  key: 2,
                  tenant: $data.tenant,
                  user: $data.user
                }, null, 8 /* PROPS */, ["tenant", "user"]))
              : _createCommentVNode("v-if", true),
            ($data.active_tab === 'stats')
              ? (_openBlock(), _createBlock(_component_UserStats, {
                  key: 3,
                  api: $options.stats_api,
                  style: {"padding":"1.6rem"}
                }, null, 8 /* PROPS */, ["api"]))
              : _createCommentVNode("v-if", true),
            ($data.active_tab === 'tasks')
              ? (_openBlock(), _createBlock(_component_Tasks, {
                  key: 4,
                  user: $data.user,
                  style: {"padding":"1.6rem"}
                }, null, 8 /* PROPS */, ["user"]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
  ]))
}